import { create } from 'zustand';
import financeiroService from '../services/financeiroService';
import toast from 'react-hot-toast';

export const useFinanceiroStore = create((set, get) => ({
  resultadoSimulacao: null,
  isSimulando: false,
  dadosProjecaoMensal: [],

  buscarProjecaoMensal: async () => {
    try {
      const dados = await financeiroService.obterProjecaoMensal();
      set({ dadosProjecaoMensal: dados });
    } catch (error) {
      console.error(error);
      toast.error('Erro ao carregar projeção mensal');
      set({ dadosProjecaoMensal: [] });
    }
  },

  executarSimulacao: async (dadosFormulario) => {
    const parseFormNum = (val) => {
      if (val === undefined || val === null || val === '') return null; 
      return Number(val.toString().replace(',', '.'));
    };
    
    const valorFobUs = parseFormNum(dadosFormulario.valorFobUs);
    const cotacaoManual = parseFormNum(dadosFormulario.cotacaoManual);
    
    // 1. Validação essencial: Sem FOB ou Câmbio, limpamos a simulação
    if (!valorFobUs || valorFobUs <= 0 || !cotacaoManual || cotacaoManual <= 0) {
      set({ resultadoSimulacao: null });
      return;
    }

    // 2. Preparamos os valores de Juros de 30% e 70%
    const possuiFinimp30 = dadosFormulario.possuiFinimp30 || false;
    const taxaJurosMensal30 = parseFormNum(dadosFormulario.taxaJurosMensal30) || 0;
    const prazoFinimp30Dias = parseInt(dadosFormulario.prazoFinimp30Dias, 10) || 0;

    const possuiFinimp70 = dadosFormulario.possuiFinimp70 || false;
    const taxaJurosMensal70 = parseFormNum(dadosFormulario.taxaJurosMensal70) || 0;
    const prazoFinimp70Dias = parseInt(dadosFormulario.prazoFinimp70Dias, 10) || 0;

    // Se o usuário MARCOU que quer Finimp, mas não preencheu os campos, não simula.
    if (possuiFinimp30 && (!taxaJurosMensal30 || !prazoFinimp30Dias)) {
      set({ resultadoSimulacao: null });
      return;
    }
    if (possuiFinimp70 && (!taxaJurosMensal70 || !prazoFinimp70Dias)) {
      set({ resultadoSimulacao: null });
      return;
    }

    set({ isSimulando: true });
    
    try {
      const totalReais = valorFobUs * cotacaoManual;
      
      // 3. Cálculo do Saldo (Balance)
      const saldoFobUs = parseFormNum(dadosFormulario.saldoFobUs);
      const saldoParaEnviar = (saldoFobUs !== null && saldoFobUs > 0) ? saldoFobUs : (valorFobUs * 0.7);
      
      // 4. ⚡ LÓGICA AUTOMÁTICA DE 50%:
      const custoDesembaracoManual = parseFormNum(dadosFormulario.custoDesembaracoBrl);
      const desembaraçoParaEnviar = (custoDesembaracoManual !== null && custoDesembaracoManual > 0)
        ? custoDesembaracoManual 
        : (totalReais * 0.50);

      const payload = {
        valorFobUs,
        saldoFobUs: saldoParaEnviar,
        cotacaoManual,
        custoDesembaracoBrl: desembaraçoParaEnviar, 
        possuiFinimp30,
        taxaJurosMensal30,
        prazoFinimp30Dias,
        possuiFinimp70,
        taxaJurosMensal70,
        prazoFinimp70Dias,
        taxaPlataforma: 0.15 
      };

      const resultado = await financeiroService.simular(payload);
      
      // 5. Cálculo Estrito do Custo Total da Operação (Saída Real de Caixa sem Margem)
      const jurosTotal = Number(resultado?.jurosTotal || 0);
      const desc_totalReais = totalReais || 0;
      const desc_desembaraco = desembaraçoParaEnviar || 0;
      const metaTotal = desc_totalReais + desc_desembaraco + jurosTotal;
      
      // Se não tem prazo, a meta mensal é o custo total/5 (proporção de venda padrão)
      const prazoMax = Math.max(
        prazoFinimp30Dias ? prazoFinimp30Dias / 30 : 0, 
        prazoFinimp70Dias ? prazoFinimp70Dias / 30 : 0
      );
      const metaMensal = (prazoMax > 0) 
        ? Number(resultado?.metaMensal || 0) 
        : (metaTotal / 5);

      const pago30 = (valorFobUs - saldoParaEnviar) * cotacaoManual;

      set({ 
        resultadoSimulacao: {
            ...resultado,
            pago30, 
            antecipacao30: pago30,
            desembaracoAplicado: desembaraçoParaEnviar, // 👈 Garantimos que esse valor vá para a tela
            jurosTotal: jurosTotal,
            metaExibicao: metaTotal,
            metaMensalExibicao: metaMensal
        }, 
        isSimulando: false 
      });
      
    } catch (error) {
      console.error(error);
      toast.error('Erro ao calcular simulação financeira.');
      set({ isSimulando: false, resultadoSimulacao: null });
    }
  },

  limparSimulacao: () => set({ resultadoSimulacao: null })
}));